module.exports = __webpack_public_path__ + "static/media/social-icon-x-aqua.648eb13e.svg";